module.exports = __webpack_public_path__ + "img/play.8569dc64.svg";